/* eslint-disable menti-react/filename-convention--jsx */
import React from 'react';
import { designSystemConfig } from '@mentimeter/ragnar-dsc';
import { ThemeProvider } from '@mentimeter/ragnar-react';
// Font sizes is created in an increasingly scale, where three
// any immediate sizes works well together

const visualizationFontSizes = [
  12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 64, 72, 80, 88, 96, 104,
];

// Overrides only the ones we need
const DSC = {
  heights: [60, 90],
  fontSizes: visualizationFontSizes,
  fontWeights: designSystemConfig.fontWeights,
};

interface Props {
  children: React.ReactNode;
}
export const InternalFontScalingProvider = (props: Props) => (
  <ThemeProvider {...props} theme={DSC} />
);
